import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AccordionItemContext from '../../js/AccordionItemContext';
import { AccordionPanelMixin } from '../../mixins/components/AccordionPanelMixin';
export var StyledAccordionPanel = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAccordionPanel",
  componentId: "c11n-8-64-0__sc-1xie7x7-0"
})(["", ""], AccordionPanelMixin);
/**
 * The `Accordion.Panel` component is used by the
 * [`Accordion.Item`](#/More%20components?id=accordion) component.
 *
 * **This component should not be used on its own.**
 *
 * @since 8.43.0
 */

var AccordionPanel = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _useContext = useContext(AccordionItemContext),
      expanded = _useContext.expanded,
      panelId = _useContext.panelId,
      headerId = _useContext.headerId;

  return /*#__PURE__*/React.createElement(StyledAccordionPanel, _extends({
    ref: forwardedRef,
    "aria-labelledby": headerId,
    id: panelId,
    hidden: !expanded
  }, props));
});
AccordionPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,

  /**
   * A [role](https://www.w3.org/TR/wai-aria-1.2/#roles) is required for assistive
   * technologies to announce the panel properly. Panel uses the
   * [region](https://www.w3.org/TR/wai-aria-1.2/#region) role.
   */
  role: PropTypes.string
} : {};
AccordionPanel.defaultProps = {
  role: 'region'
};
AccordionPanel.displayName = 'Accordion.Panel';
/** @component */

export default AccordionPanel;